var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtMoneyLarge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 100,
    viewBox: "0 0 111 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6s2zevdz1a",
    d: "M0 0h110v74H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h100v100H.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u2rv3hezhb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6s2zevdz1a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#u2rv3hezhb)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.791 19.507c-.277 0-.326.405-.055.469.585.138 1.131.127 1.182-.165.043-.246-.544-.304-1.127-.304zM66.496 15.232c.029.263.398.288.463.031.246-.968.259-2.046-.216-2.097-.401-.043-.344 1.164-.247 2.066zM69.355 17.449c-.228.13-.106.48.153.442.98-.152 1.966-.564 1.826-1.024-.118-.39-1.196.138-1.979.582zM68.933 15.66c-.21.218.102.547.326.341.284-.259.447-.522.318-.685-.11-.137-.37.06-.644.342v.002z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.62 10.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.172 22.098C3.518 18.73 17.472 1.84 17.877.286c.514-1.972 12.248 6.818 11.52 9.175-.727 2.356-16.793 21.244-18.54 21.217-2.993-.043-12.225-7.03-10.685-8.58z",
    fill: "#3EB58A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.334 22.026c2.502-3.21 15.288-17.83 16.004-19.624.654-1.641 9.83 5.47 9.197 7.515-.631 2.044-15.361 19.248-16.99 19.211-2.595-.058-9.075-5.99-8.209-7.102h-.002z",
    stroke: "#1B5B44",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.277 19.779c-1.131 0-2.118-.506-2.704-1.386a3.072 3.072 0 0 1-.432-2.359c.167-.8.71-1.972 2.345-3.008a3.071 3.071 0 0 1 1.644-.469c1.42 0 2.802.921 3.212 2.145.267.798.21 1.715-.163 2.578-.371.86-1.003 1.553-1.775 1.952-.697.36-1.43.549-2.123.549h-.004v-.002z",
    fill: "#87C9A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.128 12.677c1.374 0 2.704.886 3.098 2.062.258.769.201 1.655-.161 2.492-.361.835-.972 1.507-1.72 1.894-.68.35-1.396.534-2.07.534a3.263 3.263 0 0 1-1.496-.343 2.916 2.916 0 0 1-1.11-.99c-.437-.653-.585-1.459-.416-2.267a3.82 3.82 0 0 1 .705-1.507c.395-.527.929-1.006 1.59-1.425a2.953 2.953 0 0 1 1.58-.45m0-.239a3.17 3.17 0 0 0-1.707.487c-2.635 1.672-2.947 4.039-1.948 5.534.623.933 1.644 1.439 2.804 1.439.694 0 1.44-.181 2.178-.562 1.642-.845 2.573-2.956 1.997-4.673-.432-1.287-1.86-2.225-3.324-2.225z",
    fill: "#1B5B44"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1B5B44",
    fillRule: "nonzero",
    transform: "rotate(-50.07 19.797 10.165)",
    cx: 19.797,
    cy: 10.165,
    rx: 1.815,
    ry: 2.334
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1B5B44",
    fillRule: "nonzero",
    transform: "rotate(-50.07 9.652 22.125)",
    cx: 9.652,
    cy: 22.124,
    rx: 1.696,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.744 23.599s4.409-4.587 4.554-5.502c.144-.915-.339-1.44-.339-1.44l-4.82 5.62.605 1.322zM22.643 16.731c-.314-1.124-.746-1.58-.367-2.18.38-.598 4.416-6.427 4.628-6.145.212.281.833 1.069.63 1.509-.204.44-4.604 6.458-4.604 6.458l-.287.356v.002z",
    fill: "#1B5B44",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.311 0h110v74h-110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.503 33.1c.316-.296 4.424-3.61 5.657-3.33.642.145.407 4.642-3.868 6.003-1.675.533-2.759-2.592-2.759-2.592l.97-.08z",
    fill: "#191937",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.218 40.515c-1.75 3.54-3.963 7.248-5.72 7.635-4.723.643-8.822 1.494-14.99-.196-1.692-.464-3.536-1.118-5.594-2.019a76.016 76.016 0 0 1-3.08-1.404 88.077 88.077 0 0 1-2.882-1.458C7.596 39.189.534 34.27-8.254 29.16l.358-1.738 3.13-15.127c8.583 9.368 16.387 15.469 26.214 23.325l1.818 1.454 1.084.872a4.13 4.13 0 0 0 1.068.59c.84.3 1.68.216 2.573-.265 2.003-1.08 8.016-4.586 9.5-5.45.034-.018.069-.038.104-.059 1.664-.942 4.164-2.475 6.01-3.082 1.345-.271.593 1.225.25 2.35-.596 1.528-1.64 2.044-3.398 3.607-1.188 1.005-2.198 2.586-2.109 3.954.047.722.455 1.308 1.199 1.873 1.905 1.45 2.677-1.15 4-2.833 1.122.394 2.667 1.607 3.673 1.887v-.004h-.002z",
    fill: "#EFA88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.543 36.822c-.204.387-.483.798-.685 1.162-1.257 2.118-3.598 5.175-5.434 6.937-7.126-2.411-14.897-7.809-26.01-14.132.574-2.782 3.345-16.176 3.963-19.165 10.493 9.808 22.238 19.44 27.785 24.349.236.22.587.463.385.85h-.004z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.897 34.82a5.05 5.05 0 0 1-.449.801c-.267.41-.605.866-1.006 1.374-2.15 2.735-4.662 5.288-6.992 7.542-.454.23-11.557-5.167-22.059-13.67l.016-.078.695-3.366c.239-1.151 3.427-16.583 3.548-17.156 8.018 7.37 19.076 16.626 26.528 23.79.016.086-.226.614-.288.767h.004l.003-.005z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v74H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.105 53.545c-7.166-2.617-9.049-5.044-8.69-5.71.358-.666.764-.537 1.811-.255a40.707 40.707 0 0 1 7.244 2.737c3.309 1.626 5.64-.208 5.805-.288 2.8-1.719 6.152-2.288 6.152-2.288l3.833 7.472s-13.624-.74-16.157-1.666l.002-.002z",
    fill: "#DD9280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.516 55.531c-7.376-1.934-12.13-3.69-12.096-4.45.05-1.083 3.346-1.058 4.414-.877 1.068.18 4.342.26 7.786 1.57 3.443 1.31 5.558-.23 5.715-.324.157-.095 5.916-2.854 5.916-2.854l4.503 7.081s-13.632.54-16.24-.146h.002z",
    fill: "#E89F89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.592 54.329c1.127 1.126 10.716 2.636 13.322 3 .122.016.226.03.312.043 1.93.273 8.45-1.637 11.704 1.875.624.672 1.155 1.587 1.65 2.805.318.783.622 1.69.924 2.736.093.327.187.67.283 1.024 1.184 4.462 2.4 11.139 4.483 20.91l.091.43s.015.003.043.012c.705.2 9.779 2.675 11.967-1.006.55-.923.667-2.233.112-4.059-2.078-6.839-4.279-14.126-6.051-19.046-.522-1.45-1.007-2.694-1.44-3.66a19.142 19.142 0 0 0-.352-.749c-1.607-3.215-2.261-5.243-3.551-7.737-.22-.426-.497-.917-.844-1.32-2.33-2.712-9.36-5.122-11.572-5.928-2.343-1.635-6.009-2.348-6.754-1.026-.546.966 1.381 2.926 3.077 3.641 1.28.543 2.655 1.623 3.604 2.597.118.122.23.241.336.358.167.187.316.366.44.533.037 1.47-2.52 2.572-4.397 3.277-1.628.611-3.66.041-5.766.171-.324.018-.65.055-.976.115-1.524.278-5.694-.977-7.432-.771-.167.02-.362.047-.574.084-1.602.27-3.415.911-2.633 1.695h-.006v-.004z",
    fill: "#EDA994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.912 57.33.312.044c1.93.273 8.45-1.637 11.704 1.875.624.672 1.155 1.587 1.65 2.805.318.783.622 1.69.924 2.736l.515-.102s-.36-3.18-3.197-6.187c-2.095-2.223-8.927-1.913-11.908-1.17z",
    fill: "#1F1F39",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.602 89.93c.567 1.116 1.924 1.258 3.576.807 2.336-.635 5.268-2.444 7.434-4.357 1.954-1.725 3.284-3.532 2.987-4.636-.664-2.472-5.852-14.484-8.448-20.375a177.86 177.86 0 0 0-1.435-3.21c-.106-.218-.515-.32-1.129-.33-.403-.01-.892.024-1.44.088-2.643.31-6.614 1.365-8.526 2.325a5.545 5.545 0 0 0-.448.247c-.469.286-.717.557-.646.79.277.902.591 2.037.935 3.335 1.53 5.765 3.627 14.716 5.398 20.55l.135.441c.582 1.882 1.124 3.401 1.597 4.33l.008-.004.002-.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.025 97.153c.786 1.268 2.528 1.312 4.566.651 2.484-.801 5.41-2.646 7.596-4.587 2.11-1.873 3.53-3.837 3.203-5.05-.94-3.504-9.36-26.243-10.381-26.718-.161-.074-.457-.097-.856-.078a12.75 12.75 0 0 0-1.123.12c-.501.073-1.07.176-1.679.301-2.692.552-6.196 1.524-8.354 2.248-.22.074-.424.144-.614.212-.374.133-.686.257-.916.36-.3.135-.461.238-.447.3 1.838 7.336 5.869 27.195 9 32.243h.005v-.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.025 97.153c.786 1.268 2.528 1.312 4.566.651l-2.413-7.065c-2.977-8.714-7.074-20.683-9.18-26.701-.771-2.206-1.275-3.61-1.356-3.767l-.015-.027a5.545 5.545 0 0 0-.448.247c-.468.286-.717.557-.646.79.277.902.591 2.037.936 3.335-.3.135-.461.238-.447.3 1.838 7.336 5.869 27.195 9 32.243v-.004l.003-.002z",
    fill: "#1F1F39",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.508 47.954c-1.692-.464-3.536-1.118-5.594-2.019a76.016 76.016 0 0 1-3.08-1.404l-.05.05c-.148.15-.272.264-.364.338-.2.16-1.35-.292-3.19-1.196-.038.028-.755.8-.78.812-.454.23-11.557-5.167-22.059-13.67l.016-.078.695-3.366c4.393 3.68 14.946 10.205 23.512 14.994.952.533 1.877 1.042 2.768 1.526 3.464 1.879 6.392 3.339 8.124 4.013h.002z",
    fill: "#1F1F39",
    fillRule: "nonzero",
    opacity: 0.08
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtMoneyLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-money-large.863299fa439b18ee15e9ba342b9bf1ef.svg";